<template>
    <!-- May be nested inside other BUI dialogs (e.g. the Create User flow):
         both are z-[10000] Headless UI dialogs; the later-mounted nested one
         stacks above (Phase 1 convention). -->
    <Dialog :expanderClass="'d-inline'" ref="organization" panelClass="bui-dialog-panel">
      <template #expander="{ openModal }">
    <ButtonCustomized :label="btnTitle" @click="openModal" v-if="showBtn" /> 
        <button type="button" @click="openModal" v-if="!showBtn" class="change-link">{{ btnTitle }}</button>
  
      </template>
      <template #dialog.title>
        Select Organization
      </template>
      <template #dialog.content="{ closeModal, closeModalAfter }">
  
  
        <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
        <div>

            <SimpleEntityListingPage
            entityItemsNamePlural=""
    entityItemName="''"
    areaAccessName="Administration"
    :ItemsLister="OrganizationsLister"
    :singleSelect = true 
  />

          <div class="form-buttons">
            <ButtonCustomized label="Add" cta @click="onSave" />
          </div>
        </div>
  
      </template>
    </Dialog>
  </template>
      
  <script lang="ts" setup>
  import Dialog from '@/components/Dialog/Dialog.vue';
  import ButtonCustomized from "@/components/form-fields/ButtonCustomized.vue";
  import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
  import OrganizationsLister from '../../OrganizationsListView/OrganizationsLister/OrganizationsLister.vue';
  import useListSelection from '@/components/ListingPages/ItemsLister/ItemsList/composables/listSelection';
  import { ref } from 'vue';
  const organization = ref()
  const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
  defineProps({
    'showBtn':{
      type: Boolean,
      default: true
    },
    'btnTitle':{
        type: String , 
        default :'Select Group'
    }
  
  })
  const {
    selectedItemsIds,
    selectedItems,
    clearItemsSelection
  } = useListSelection({
    clearSelectionTriggerElement: document.body
  });
  
  function onExit() {
    emit('exit')
  }
  async function onSave() {
    emit('save', selectedItems[0]);
    clearItemsSelection () ;
    organization.value.closeModal()
  }
  
  </script>
      
  <style lang="scss" scoped>
  .button {
    cursor: pointer;
  }
  
  .delete-item-form {
    display: flex;
    flex-direction: column;
    max-width: 30rem;
  }
  
  .form-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    margin-top: 1rem;
  }
  .change-link {
    border: 0;
    background: transparent;
    font-family: inherit;
    padding: 0;
    cursor: pointer;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 6px;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.04em;
    color: var(--bui-tbl-row-link, #4b1886);
    font-weight: bold;
  }
  .change-link:hover{
    text-decoration: underline;
}
  .change-link:focus-visible {
    outline: 2px solid var(--bui-chk-checked-fill, #de3da9);
    outline-offset: 2px;
  }
  
  </style>